import axios from "axios";
import download from "downloadjs";
import { SERVER_URL, SERVER_IP } from "../app/ServerConfig";
import { API } from "../app/utils/const";
import { getPublicIP } from "../app/utils/utils";

export const getCall = (url) =>
  new Promise(async (resolve) => {
    const ip = await getPublicIP();
    const baseUrl = `${SERVER_URL}/${API}${url}`;
    axios
      .get(baseUrl, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
          IP: ip,
        },
        credentials: "include",
      })
      .then((res) => (res.status === 204 ? {} : res.data))
      .then((json) => resolve(json))
      .catch((error) => {
        if (error && error.response) {
          resolve(error.response.data);
        }
      });
  });

export const getPDFCall = (url, customPdfName, extention) =>
  new Promise(async (resolve) => {
    const ip = await getPublicIP();
    const baseUrl = `${SERVER_URL}/${API}${url}`;
    axios
      .get(baseUrl, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
          IP: ip,
        },
        credentials: "include",
        responseType: "blob",
      })
      .then((res) => {
        const content = res.headers["content-type"];
        download(res.data, `${customPdfName}.${extention}`, content);
        resolve({ res });
      })
      .catch((error) => {
        console.log("error", error);
        if (error && error.response) {
          resolve(error.response.data);
        }
      });
  });

export const getPDFPrintCall = (url) =>
  new Promise(async (resolve) => {
    const ip = await getPublicIP();
    const baseUrl = `${SERVER_URL}/${API}${url}`;
    axios
      .get(baseUrl, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
          IP: ip,
        },
        credentials: "include",
        responseType: "blob",
      })
      .then((res) => {
        resolve({ res });
      })
      .catch((error) => {
        if (error && error.response) {
          resolve(error.response.data);
        }
      });
  });

export const postCall = (url, data = {}) =>
  new Promise(async (resolve) => {
    const ip = await getPublicIP();
    const baseUrl = `${SERVER_URL}/${API}${url}`;
    axios
      .post(baseUrl, data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
          IP: ip,
        },
        credentials: "include",
      })
      .then((res) => (res.status === 204 ? {} : res.data))
      .then((json) => resolve(json))
      .catch((error) => {
        if (error && error.response) {
          resolve(error.response.data);
        }
      });
  });

export const patchCall = (url, data = {}) =>
  new Promise(async (resolve) => {
    const baseUrl = `${SERVER_URL}/${API}${url}`;
    const ip = await getPublicIP();
    axios
      .patch(baseUrl, data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
          IP: ip,
        },
        credentials: "include",
      })
      .then((res) => (res.status === 204 ? {} : res.data))
      .then((json) => resolve(json))
      .catch((error) => {
        if (error && error.response) {
          resolve(error.response.data);
        }
      });
  });

export const putCall = (url, data = {}) =>
  new Promise(async (resolve) => {
    const baseUrl = `${SERVER_URL}/${API}${url}`;
    const ip = await getPublicIP();
    axios
      .put(baseUrl, data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
          IP: ip,
        },
        credentials: "include",
      })
      .then((res) => (res.status === 204 ? {} : res.data))
      .then((json) => resolve(json))
      .catch((error) => {
        if (error && error.response) {
          resolve(error.response.data);
        }
      });
  });

export const deleteCall = (url, data = {}) =>
  new Promise(async (resolve) => {
    const ip = await getPublicIP();
    const baseUrl = `${SERVER_URL}/${API}${url}`;
    axios
      .delete(baseUrl, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
          IP: ip,
        },
        credentials: "include",
      })
      .then((res) => (res.status === 204 ? {} : res.data))
      .then((json) => resolve(json))
      .catch((error) => {
        if (error && error.response) {
          resolve(error.response.data);
        }
      });
  });

export const postCallWithMedia = (url, data = {}) =>
  new Promise(async (resolve) => {
    const baseUrl = `${SERVER_URL}/${API}${url}`;
    const formData = new FormData();
    const ip = await getPublicIP();
    formData.append(data.containername, data.file);
    axios({
      method: "POST",
      url: baseUrl,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
        IP: ip,
      },
    })
      .then((res) => (res.status === 204 ? {} : res.data))
      .then((json) => resolve(json))
      .catch((error) => {
        if (error && error.response) {
          resolve(error.response.data);
        }
      });
  });
